import { store } from '@store/index';

import { AbstractField } from './AbstractField';

export class MaterialActField extends AbstractField<object, string> {
    public get hasData(): boolean {
        const {
            entry: { materialAct, entryExpensesAllocations = [] },
            expensesAllocationStore: { availableExpensesAllocations },
        } = store;

        return (
            (materialAct?.materials ?? []).length > 0 ||
            entryExpensesAllocations.length > 0 ||
            availableExpensesAllocations.length > 0
        );
    }
    public makeUpdateParams(): string {
        return '';
    }
    protected setFieldValue(_: string | object): void {}
}
